import {isString} from 'lodash';

export function isTextSearchFilterTabActive(filterParams) {
    return isString(filterParams?.text);
}
